import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.ABTest {
  export const GetABCookie = async (): Promise<any> => {
    const url = `/api/abtest?handler=abcookie`;
    return easyfyAxios.get(
      url
    );
  };
}

export default Easyfy.Web.Services.ABTest;
